import { orientation, format, PageOption } from './';

export const pageOptions: PageOption[] = [
    {
        name: 'A3 - portrait',
        configuration: {
            format: format.A3,
            orientation: orientation.Portrait,
            columns: 12,
            rows: 100
        }
    }, {
        name: 'A3 - landscape',
        configuration: {
            format: format.A3,
            orientation: orientation.Landscape,
            columns: 12,
            rows: 67
        }
    },
    {
        name: 'A4 - landscape',
        configuration: {
            format: format.A4,
            orientation: orientation.Landscape,
            columns: 12,
            rows: 43
        }
    },
    {
        name: 'A4 - portrait (6 columns)',
        configuration: {
            format: format.A4,
            orientation: orientation.Portrait,
            columns: 6,
            rows: 80
        }
    }
];